import Axios from "../../../../api/axios/Axios";

export const getSharedTalents = (limit = 12, offset = 0, signal, seed) =>
  Axios.get("/api/talents/shared", {
    params: {
      limit,
      offset,
      ...(seed != null ? { seed } : {}),
    },
    signal,
  });

export const getSharedTalent = (talentTag, signal) =>
  Axios.get(`/api/talents/shared/${encodeURIComponent(talentTag)}`, { signal });
